const modalApi = Symbol('modalApiKey');

export default modalApi;
